import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Color } from '@diritto/common/style/color';

type SwitchButtonProps = {
  className?: string;
  id: string;
  checked: boolean;
  onChange?: () => void;
  size?: SwitchButtonSizeType;
  disabled?: boolean;
};

type SwitchButtonSizeType = {
  width: string;
  height: string;
  sliderSize: string;
  translateX: string;
};

export const SwitchButtonSize: { [key: string]: SwitchButtonSizeType } = {
  small: {
    width: '34px',
    height: '20px',
    sliderSize: '16px',
    translateX: '14px',
  },
  large: {
    width: '48px',
    height: '28px',
    sliderSize: '24px',
    translateX: '20px',
  },
};

export const SwitchButton = ({
  className,
  id,
  checked,
  onChange,
  size = SwitchButtonSize.large,
  disabled = false,
}: SwitchButtonProps) => (
  <StyledWrapper className={className} sizeInfo={size} disabled={disabled}>
    <SwitchWrapper sizeInfo={size}>
      <StyledInput type="checkbox" checked={checked} onChange={onChange} id={id} sizeInfo={size} />
      <Slider htmlFor={id} sizeInfo={size} />
    </SwitchWrapper>
  </StyledWrapper>
);

const StyledWrapper = styled.div(
  ({ sizeInfo, disabled }: { sizeInfo: SwitchButtonSizeType; disabled: boolean }) => css`
    height: ${sizeInfo.height};
    opacity: ${disabled ? 0.3 : 1};
  `,
);

const SwitchWrapper = styled.div(
  ({ sizeInfo }: { sizeInfo: SwitchButtonSizeType }) => css`
    position: relative;
    display: inline-block;
    width: ${sizeInfo.width};
    height: ${sizeInfo.height};
  `,
);

const Slider = styled.label(
  ({ sizeInfo }: { sizeInfo: SwitchButtonSizeType }) => css`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    background-color: ${Color.Gray300};
    -webkit-transition: 0.4s;
    transition: 0.4s;

    &:before {
      position: absolute;
      content: '';
      width: ${sizeInfo.sliderSize};
      height: ${sizeInfo.sliderSize};
      left: 2px;
      top: 2px;
      border-radius: 50%;
      background-color: ${Color.White};
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  `,
);

const StyledInput = styled.input(
  ({ sizeInfo }: { sizeInfo: SwitchButtonSizeType }) => css`
    opacity: 0;
    width: 0;
    height: 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &:checked + ${Slider} {
      background-color: ${Color.Primary500};
    }

    &:checked + ${Slider}:before {
      transform: translateX(${sizeInfo.translateX});
    }
  `,
);
